import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * Banner shown at the top of every page when an admin is impersonating another user.
 * Allows one-click return to the admin account.
 */
export default function ImpersonationBanner() {
    const { user, refresh } = useAuth();
    const navigate = useNavigate();

    if (!user || !user.is_impersonating) return null;

    const stop = async () => {
        try {
            const { data } = await api.post("/admin/stop-impersonation");
            toast.success(`Retour au compte ${data.back_to}`);
            if (refresh) await refresh();
            navigate("/admin", { replace: true });
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Impossible de revenir au compte admin.");
        }
    };

    return (
        <div
            className="sticky top-0 z-40 bg-amber-500 text-ink border-b border-amber-700 shadow-sm"
            data-testid="impersonation-banner"
        >
            <div className="max-w-7xl mx-auto px-4 lg:px-8 py-2.5 flex items-center justify-between gap-3 text-sm">
                <div className="flex items-center gap-2 min-w-0">
                    <ShieldAlert size={16} className="shrink-0" />
                    <span className="truncate">
                        <strong>Mode admin :</strong> vous êtes connectée en tant que{" "}
                        <strong>{user.email}</strong> ({user.role})
                    </span>
                </div>
                <button
                    onClick={stop}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-ink text-white text-xs font-medium hover:bg-ink/90 transition-colors shrink-0"
                    data-testid="impersonation-stop-button"
                >
                    <LogOut size={12} /> Retour admin
                </button>
            </div>
        </div>
    );
}
